import axios from 'axios';
import PrimeVue from 'primevue/config';
import type { App } from 'vue';

import { all } from '@awesome.me/kit-d3c0f9ff86/icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { createHead } from '@unhead/vue/client';
import { createPinia } from 'pinia';
import piniaPluginPersistedState from 'pinia-plugin-persistedstate';
import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';

import { allComponents } from './components';
import { ClosinglockDesignSystem } from './design-system';
import { useCurrentUserService } from './services/current-user.service';

library.add(...(all as IconDefinition[]));

axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': window.csrf ?? '',
};

/** Applies to an externally created vue app the libraries and components known to the module */
export function decorate(app: App, addComponents = false) {
    const pinia = createPinia();
    pinia.use(piniaPluginPersistedState);
    app.use(pinia);
    app.use(createHead());

    if (addComponents) {
        for (const componentName of Object.keys(allComponents)) {
            const castedName = componentName as keyof typeof allComponents;
            app.component(componentName, allComponents[castedName]);
        }
        app.component('font-awesome-icon', FontAwesomeIcon);
    }

    installPrimeVue(app);

    const currentUserService = useCurrentUserService();
    currentUserService.loadGlobalUserOrLogout();
}

export function installPrimeVue(app: App) {
    app.use(PrimeVue, {
        unstyled: true,
        pt: ClosinglockDesignSystem,
        ptOptions: { mergeProps: true, mergeSections: true },
    });
    app.use(ToastService);
    app.directive('tooltip', Tooltip);
}
